import React, { useState, useEffect } from "react";
import Header from "../../Layouts/Header";
import Footer from "../../Layouts/Footer";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Breadcrumb from "../../Layouts/Breadcrumb";
import Typography from "@material-ui/core/Typography";
import { TextField } from "@material-ui/core";
import "./Ticket.css";
// import Radio from "@material-ui/core/Radio";
// import RadioGroup from "@material-ui/core/RadioGroup";
// import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
// import FormLabel from "@material-ui/core/FormLabel";
import Button from "@material-ui/core/Button";
// import LoadderButton from "../../Layouts/LoadderButton";
import AuthApi from "../../Services/Authapi";
// import Paper from "@material-ui/core/Paper";
// import FontAwesomeIconComponent from "../../Layouts/FontAwesomeIconComponent";
// import { SignalCellularNull } from "@material-ui/icons";
// import Authapi from "../../Services/Authapi";
import swal from "sweetalert";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
// import { now } from "moment";
import moment from "moment";
// import CircularProgress from "@material-ui/core/CircularProgress";
import ls from "local-storage";
import DdMmYyyyDateField from "../../../utils/DdMmYyyyDateField";
import { useLocation } from "react-router-dom";
import AuthCheckComponent from '../../Layouts/Token';
import { createSwalLoaderNode } from "../../Layouts/swalLoader";

const iniTickets = {
  leaveType: "",
  ticketMesasge: "",
  dateRange: "",
  startDate: "",
  endDate: "",
  noOfDays: "",
  firstleavetype: "",
  secondleavetype: "",
};

const leaveTypeOptions = [
  "Loss Of Pay",
  "Sick Leave",
  "Paid Leave",
];

const AddTickets = (props) => {
  const classes = props;
  const [ticketValues, setTicketsValues] = useState(iniTickets);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const stateData = location.state || {};
  const leaveDate = stateData.date || queryParams.get("date");
  const endDateParam = stateData.endDate || queryParams.get("endDate");
  const leaveTypeParam = stateData.type || queryParams.get("type");
  const messageParam = stateData.message || queryParams.get("message");

  const parseDateInput = (value) => {
    if (!value) {
      return null;
    }

    const parsedDate = moment(value, [
      "YYYY-MM-DD",
      "MM/DD/YYYY",
      "M/D/YYYY",
      "DD/MM/YYYY",
      "D/M/YYYY",
      "DD-MM-YYYY",
      "D-M-YYYY",
    ], true);

    return parsedDate.isValid() ? parsedDate : null;
  };

  const normalizeDateInput = (value) => {
    const parsedDate = parseDateInput(value);
    return parsedDate ? parsedDate.format("YYYY-MM-DD") : value;
  };

  const getComparableDate = (value) => {
    const parsedDate = parseDateInput(value);
    return parsedDate && parsedDate.year() >= 1000 ? parsedDate : null;
  };

  const getDateFieldError = (name, value, values = ticketValues) => {
    const trimmedValue = value ? value.trim() : "";

    if (!trimmedValue) {
      return "";
    }

    const selectedDate = getComparableDate(trimmedValue);
    if (!selectedDate) {
      return "Invalid date";
    }

    if (name === "startDate") {
      const parsedEndDate = getComparableDate(values.endDate);
      if (parsedEndDate && selectedDate.isAfter(parsedEndDate, "day")) {
        return "Start date cannot be after end date";
      }
    }

    if (name === "endDate") {
      const parsedStartDate = getComparableDate(values.startDate);
      if (parsedStartDate && selectedDate.isBefore(parsedStartDate, "day")) {
        return "End date cannot be before start date";
      }
    }

    return "";
  };

  useEffect(() => {
    if (leaveDate) {
      const formattedDate = normalizeDateInput(leaveDate);
      const formattedEndDate = endDateParam ? normalizeDateInput(endDateParam) : formattedDate;
      setTicketsValues({
        ...iniTickets,
        startDate: formattedDate,
        endDate: formattedEndDate,
        leaveType: leaveTypeParam || leaveTypeOptions[0],
        ticketMesasge: messageParam || "Pending Leave",
      });
    }
  }, [leaveDate, endDateParam, leaveTypeParam, messageParam]);

  useEffect(() => {
    if (props.authToken === false) {
      // props.history.push("/login");
    }
  }, [props.authToken, props.history]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "leaveType") {
      const nextValues = { ...ticketValues, leaveType: value };
      const nextErrors = { ...formErrors };

      ["startDate", "endDate"].forEach((fieldName) => {
        const fieldValue = nextValues[fieldName];
        if (!fieldValue) {
          delete nextErrors[fieldName];
          return;
        }

        const fieldError = getDateFieldError(fieldName, fieldValue, nextValues);
        if (fieldError) {
          nextErrors[fieldName] = fieldError;
        } else {
          delete nextErrors[fieldName];
        }
      });

      setTicketsValues(nextValues);
      setFormErrors(nextErrors);
      return;
    }

    if (name === "startDate") {
      const normalizedStartDate = value ? normalizeDateInput(value) : "";
      const nextValues = { ...ticketValues, startDate: normalizedStartDate };
      const startDateError = getDateFieldError("startDate", normalizedStartDate, nextValues);

      if (startDateError === "Start date cannot be after end date") {
        swal("Invalid Date", startDateError, "error");
        setTicketsValues({ ...nextValues, endDate: "" });
        setFormErrors((prevErrors) => {
          const nextErrors = { ...prevErrors };
          delete nextErrors.startDate;
          delete nextErrors.endDate;
          return nextErrors;
        });
        return;
      }

      setTicketsValues(nextValues);
      setFormErrors((prevErrors) => {
        const nextErrors = { ...prevErrors };
        if (startDateError) {
          nextErrors.startDate = startDateError;
        } else {
          delete nextErrors.startDate;
        }

        if (nextValues.endDate) {
          const endDateError = getDateFieldError("endDate", nextValues.endDate, nextValues);
          if (endDateError) {
            nextErrors.endDate = endDateError;
          } else {
            delete nextErrors.endDate;
          }
        } else {
          delete nextErrors.endDate;
        }

        return nextErrors;
      });
      return;
    }

    if (name === "endDate") {
      const normalizedEndDate = value ? normalizeDateInput(value) : "";
      const nextValues = { ...ticketValues, endDate: normalizedEndDate };
      const endDateError = getDateFieldError("endDate", normalizedEndDate, nextValues);

      if (endDateError === "End date cannot be before start date") {
        swal("Invalid Date", endDateError, "error");
        return;
      }

      setTicketsValues(nextValues);
      setFormErrors((prevErrors) => {
        const nextErrors = { ...prevErrors };
        if (endDateError) {
          nextErrors.endDate = endDateError;
        } else {
          delete nextErrors.endDate;
        }
        return nextErrors;
      });
      return;
    }

    setTicketsValues({ ...ticketValues, [name]: value });
  };

  function dateDiffInDays(startDate, endDate) {
    return Math.round((endDate - startDate) / (1000, 60, 60 * 24));
  }
  const daysDiff = dateDiffInDays(
    new Date(ticketValues.startDate),
    new Date(ticketValues.endDate)
  );
  const today = new Date();
  const date =
    today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
  const dsp = dateDiffInDays(new Date(date), new Date(ticketValues.startDate));


  const validate = (values) => {
    let errors = {};
    const regex = /^[a-zA-Z]/;
    if (!values.leaveType) {
      errors.leaveType = "Cannot be blank";
    }

    if (!values.ticketMesasge) {
      errors.ticketMesasge = "Cannot be blank";
    } else if (!regex.test(values.ticketMesasge)) {
      errors.ticketMesasge = "Invalid ticketMesasge format";
    }

    if (!values.firstleavetype) {
      errors.firstleavetype = "Cannot be blank";
    } else if (!regex.test(values.firstleavetype)) {
      errors.firstleavetype = "Invalid ticketMesasge format";
    }

    if (!values.secondleavetype) {
      errors.secondleavetype = "Cannot be blank";
    } else if (!regex.test(values.secondleavetype)) {
      errors.secondleavetype = "Invalid ticketMesasge format";
    }

    if (!values.startDate) {
      errors.startDate = "Cannot be blank";
    } else {
      const startDateError = getDateFieldError("startDate", values.startDate, values);
      if (startDateError) {
        errors.startDate = startDateError;
      }
    }

    if (!values.endDate) {
      errors.endDate = "Cannot be blank";
    } else {
      const endDateError = getDateFieldError("endDate", values.endDate, values);
      if (endDateError) {
        errors.endDate = endDateError;
      }
    }

    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // setIsLoading(true);
    setFormErrors(validate(ticketValues));
    setIsSubmitting(true);
  };


  useEffect(() => {
    if (Object.keys(formErrors).length === 0 && isSubmitting) {
      Tickets();
      // setIsLoading(false);
    }
  }, [formErrors]);

  // const Tickets = async () => {
  //   swal({
  //     title: "Loading",
  //     text: "Please wait...",
  //     buttons: false,
  //     closeOnClickOutside: false,
  //     closeOnEsc: false,
  //     width: "10%",
  //     content: {
  //       element: "img",
  //       attributes: {
  //         src: "https://www.boasnotas.com/img/loading2.gif",
  //         style: "width: 50px;" // Adjust the width as needed
  //       }
  //     }
  //   });
  //   // 
  //   let create1 = await AuthApi.createTicket(ticketValues);
  //   swal.close();
  //   if (create1 && create1.status === true) {
  //     props.history.push("/tickets");
  //   } else {
  //     swal.close();
  //     swal({
  //       title: "OOPS!",
  //       icon: "fail",
  //       message: "Something went wrong, Please try later!",
  //     });
  //   }
  // };

  const Tickets = async () => {
    swal({
      title: "Loading",
      text: "Please wait...",
      buttons: false,
      closeOnClickOutside: false,
      closeOnEsc: false,
      content: createSwalLoaderNode(),
    });
    try {
      const payload = {
        ...ticketValues,
        dateRange: ticketValues.dateRange || [ticketValues.startDate, ticketValues.endDate],
      };
      let create1 = await AuthApi.createTicket(payload);
      swal.close();
      if (create1 && create1.status === true) {
        swal("Success", "Ticket created successfully!", "success");
        try {
          const user = ls("user");
          const userName = user ? `${user.firstName || ''} ${user.lastName || ''}`.trim() : "User";
          window.dispatchEvent(
            new CustomEvent("cherrypik_new_notification", {
              detail: {
                title: "Leave Ticket",
                message: `${userName} created a leave ticket (${ticketValues.startDate}${ticketValues.endDate && ticketValues.endDate !== ticketValues.startDate ? ' To ' + ticketValues.endDate : ''})`,
                type: "Leave Ticket",
              },
            })
          );
          window.dispatchEvent(new Event("cherrypik_refresh_notifications"));
        } catch (e) {
          // ignore
        }
        props.history.push("/leave-tickets");
      } else {
        swal("Error", create1, "error");
      }
    } catch (error) {
      swal("Error", "An error occurred, Please try again later!", "error");
    }
  };

  function diffday() {
    const startDate = normalizeDateInput(ticketValues.startDate);
    const endDate = normalizeDateInput(ticketValues.endDate);
    const a = getComparableDate(startDate);
    const b = getComparableDate(endDate);
    const dateRangeArr = [];
    dateRangeArr.push(startDate);
    dateRangeArr.push(endDate);
    ticketValues.dateRange = dateRangeArr;
    if (ticketValues.firstleavetype === "first-half" && ticketValues.secondleavetype === "first-half") {
      ticketValues.noOfDays = 0.5;
    } else if (ticketValues.firstleavetype === "second-half" && ticketValues.secondleavetype === "second-half") {
      ticketValues.noOfDays = 0.5;
    }
    else {
      ticketValues.noOfDays = a && b ? b.diff(a, "days") + 1 : 0;
    }
  }

  return (
    <div>
      <AuthCheckComponent authToken={props.authToken} />
      <Header
        {...props}
        authUser={props.authUser}
        component={
          <div>
            <div className="holiday-breadcrumb-card">
                <Breadcrumb
                  {...props}
                  primaryPageName="Leaves Ticket"
                  primaryPageLink="/leave-tickets"
                  isSecondaryPage={true}
                  secondaryPageName="Add Leave Ticket"
                />
            </div>
            <div className="holiday-form-card">
                <Typography variant="h2" className="holiday-form-title" style={{ color: '#036dda', fontSize: '24px', fontWeight: 'bold', marginBottom: '20px' }}>
                    Add Tickets
                </Typography>
                <form className={`${classes.form} common-form-fields leave-ticket-form`} onSubmit={handleSubmit}>
                      <Grid container className={classes.root} spacing={5}>
                        <Grid item xs={12}>
                          <FormControl
                            variant="outlined"
                            style={{ width: "100%" }}
                          >
                            <InputLabel id="demo-simple-select-outlined-label">
                              Leave-Type
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-outlined-label"
                              id="demo-simple-select-outlined"
                              label="Leave-Type"
                              name="leaveType"
                              error={formErrors.leaveType && true}
                              value={ticketValues.leaveType}
                              onChange={handleChange}
                              className={formErrors.leaveType && "input-error"}
                              MenuProps={{ classes: { paper: 'holiday-form-menu' } }}
                            >
                              {leaveTypeOptions.map((leaveType) => (
                                <MenuItem key={leaveType} value={leaveType}>
                                  {leaveType}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                          {formErrors.leaveType && (
                            <span className="error">
                              {formErrors.leaveType}
                            </span>
                          )}
                        </Grid>

                        <Grid item xs={6}>
                          <DdMmYyyyDateField
                            id="startDate"
                            name="startDate"
                            label="Start-date"
                            error={formErrors.startDate && true}
                            value={ticketValues.startDate}
                            onChange={handleChange}
                            className={`${classes.textField} ${formErrors.startDate ? "input-error" : ""}`}
                            max={ticketValues.endDate || undefined}
                          />
                          {formErrors.startDate && (
                            <span className="error">
                              {formErrors.startDate}
                            </span>
                          )}
                        </Grid>

                        <Grid item xs={6}>
                          <FormControl
                            variant="outlined"
                            style={{ width: "100%" }}
                          >
                            <InputLabel id="demo-simple-select-outlined-label">
                              Select-Half
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-outlined-label"
                              id="demo-simple-select-outlined"
                              label="Select-Half"
                              error={formErrors.firstleavetype && true}
                              name="firstleavetype"
                              // className={classes.firstleavetype}
                              // error={formErrors.leaveType && true}
                              value={ticketValues.firstleavetype}
                              onChange={handleChange}
                              MenuProps={{ classes: { paper: 'holiday-form-menu' } }}
                            // className={formErrors.leaveType && "input-error"}
                            >
                              <MenuItem value="first-half">First Half</MenuItem>
                              <MenuItem value="second-half">
                                Second Half
                              </MenuItem>
                            </Select>
                            {formErrors.firstleavetype && (
                              <span className="error">
                                {formErrors.firstleavetype}
                              </span>
                            )}
                          </FormControl>
                        </Grid>

                        <Grid item xs={6}>
                          <DdMmYyyyDateField
                            id="endDate"
                            name="endDate"
                            label="End-date"
                            error={formErrors.endDate && true}
                            value={ticketValues.endDate}
                            onChange={handleChange}
                            className={`${classes.textField} ${formErrors.endDate ? "input-error" : ""}`}
                            min={ticketValues.startDate || undefined}
                          />
                          {formErrors.endDate && (
                            <span className="error">{formErrors.endDate}</span>
                          )}
                        </Grid>

                        <Grid item xs={6}>
                          <FormControl
                            variant="outlined"
                            style={{ width: "100%" }}
                          >
                            <InputLabel id="demo-simple-select-outlined-label">
                              Select-Half
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-outlined-label"
                              id="demo-simple-select-outlined"
                              label="Select-Half"
                              name="secondleavetype"
                              error={formErrors.secondleavetype && true}
                              // error={formErrors.leaveType && true}
                              value={ticketValues.secondleavetype}
                              onChange={handleChange}
                              MenuProps={{ classes: { paper: 'holiday-form-menu' } }}
                            // className={formErrors.leaveType && "input-error"}
                            >
                              <MenuItem value="first-half">First Half</MenuItem>
                              <MenuItem value="second-half">
                                Second Half
                              </MenuItem>
                            </Select>
                            {formErrors.secondleavetype && (
                              <span className="error">
                                {formErrors.secondleavetype}
                              </span>
                            )}
                          </FormControl>
                          {/* {formErrors.leaveType && (
                                                        <span className="error">{formErrors.leaveType}</span>
                                                    )} */}
                        </Grid>

                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            multiline
                            rows={4}
                            id="ticketMesasge"
                            name="ticketMesasge"
                            label="Reason for Leave"
                            variant="outlined"
                            error={formErrors.ticketMesasge && true}
                            value={ticketValues.ticketMesasge}
                            onChange={handleChange}
                            className={
                              formErrors.ticketMesasge && "input-error"
                            }
                          />
                          {formErrors.ticketMesasge && (
                            <span className="error">
                              {formErrors.ticketMesasge}
                            </span>
                          )}
                        </Grid>
                      </Grid>

                      <Grid container className={classes.root} spacing={3}>
                        <Grid item xs={4} style={{ display: "flex" }}>
                          <Button
                            type="submit"
                            onClick={(e) => {
                              diffday();
                            }}
                            className="btn-success"
                            style={{ marginTop: "10px", textTransform: 'none' }}
                            variant="contained"
                            color="primary"
                          >
                            Save
                          </Button>
                          <Button
                            type="button"
                            className="btn-cancel"
                            style={{ marginTop: "10px", textTransform: 'none' }}
                            onClick={(e) => {
                              e.preventDefault();
                              props.history.push("/leave-tickets");
                            }}
                          >
                            Cancel
                          </Button>
                        </Grid>
                        <Grid item xs={4}></Grid>
                        <Grid item xs={4}></Grid>
                      </Grid>
                    </form>
            </div>
          </div>
        }
      />
      <Footer />
    </div>
  );
};

export default AddTickets;
